<template>
  <div class="hr-modal-overlay" @click.self="$emit('close')">
    <div class="hr-modal-container hr-modal-lg">
      <div class="hr-modal-header">
        <h3>Assign Designation: {{ position?.positionName }}</h3>
        <button type="button" class="hr-modal-close" @click="$emit('close')">
          <i class="bx bx-x"></i>
        </button>
      </div>
      
      <div class="hr-modal-body">
        <!-- Search employees -->
        <div class="hr-form-group">
          <div class="assign-search-wrap">
            <i class="bx bx-search-alt search-icon"></i>
            <input v-model="searchQuery"
                   type="text"
                   class="hr-input"
                   placeholder="Search employees...">
          </div>
        </div>

        <!-- Employees list -->
        <div class="assign-employees-list">
          <div v-if="loading" class="hr-loading-small">
            <div class="hr-spinner small"></div>
            <span>Loading employees...</span>
          </div>

          <div v-else-if="filteredEmployees.length === 0" class="hr-empty-small">
            <i class="bx bx-user-x"></i>
            <p>No available employees found</p>
          </div>

          <div v-else v-for="emp in filteredEmployees" :key="emp.id" class="assign-employee-item">
            <div class="employee-info">
              <div class="employee-avatar">
                <i class="bx bx-user-circle"></i>
              </div>
              <div class="employee-details">
                <h4>{{ emp.fullName }}</h4>
                <p>{{ emp.employeeId }} • {{ emp.department || 'No Department' }}</p>
              </div>
            </div>
            <button type="button" 
                    class="hr-btn hr-btn-sm hr-btn-success"
                    @click="assignToEmployee(emp)"
                    :disabled="assigning === emp.id">
              <i v-if="assigning === emp.id" class="bx bx-loader-alt bx-spin"></i>
              {{ assigning === emp.id ? 'Assigning...' : 'Assign' }}
            </button>
          </div>
        </div>
      </div>

      <div class="hr-modal-footer">
        <button type="button" class="hr-btn hr-btn-secondary" @click="$emit('close')">
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { authUrl, execute } from "@/api";

export default {
  name: "AssignPositionModal",
  props: {
    position: {
      type: Object,
      required: true
    },
    employees: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      assigning: null,
      searchQuery: '',
      availableEmployees: []
    };
  },
  computed: {
    filteredEmployees() {
      if (!this.searchQuery) {
        return this.availableEmployees;
      }
      const query = this.searchQuery.toLowerCase();
      return this.availableEmployees.filter(emp =>
          emp.fullName.toLowerCase().includes(query) ||
          emp.employeeId.toLowerCase().includes(query)
      );
    }
  },
  mounted() {
    this.loadAvailableEmployees();
  },
  methods: {
    loadAvailableEmployees() {
      this.loading = true;
      
      const data = new FormData();
      data.append("function", "getAvailableEmployees");
      data.append("positionId", this.position.id);

      execute(data, authUrl)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.availableEmployees = res.data.data.employees || [];
            } else {
              this.$toast.error(res.data.message || "Failed to load employees");
            }
          })
          .catch((e) => {
            this.loading = false;
            this.$toast.error("Error loading employees: " + e.message);
          });
    },

    assignToEmployee(employee) {
      this.assigning = employee.id;

      const data = new FormData();
      data.append("function", "assignPosition");
      data.append("employeeId", employee.id);
      data.append("positionId", this.position.id);

      execute(data, authUrl)
          .then((res) => {
            this.assigning = null;
            if (res.data.success) {
              this.$toast.success(`Position assigned to ${employee.fullName} successfully`);
              this.$emit('assigned', res.data.data);
              this.loadAvailableEmployees();
            } else {
              this.$toast.error(res.data.message || "Failed to assign position");
            }
          })
          .catch((e) => {
            this.assigning = null;
            this.$toast.error("Error assigning position: " + e.message);
          });
    }
  }
};
</script>

<style scoped>
.assign-search-wrap { position: relative; }
.assign-search-wrap .search-icon { position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: #94a3b8; }
.assign-search-wrap .hr-input { padding-left: 40px; }

.assign-employees-list { max-height: 400px; overflow-y: auto; border: 1px solid #e2e8f0; border-radius: 8px; }
.assign-employee-item { display: flex; justify-content: space-between; align-items: center; padding: 12px 16px; border-bottom: 1px solid #e2e8f0; }
.assign-employee-item:last-child { border-bottom: none; }
.employee-info { display: flex; align-items: center; gap: 12px; }
.employee-avatar { font-size: 32px; color: #94a3b8; }
.employee-details h4 { margin: 0; font-size: 0.95rem; }
.employee-details p { margin: 4px 0 0; font-size: 0.8rem; color: #64748b; }

.hr-loading-small { display: flex; align-items: center; justify-content: center; gap: 10px; padding: 2rem; }
.hr-empty-small { text-align: center; padding: 2rem; color: #64748b; }
.hr-empty-small i { font-size: 32px; margin-bottom: 8px; }
.hr-spinner.small { width: 20px; height: 20px; border-width: 2px; }
</style>